import ReactOnClickOutside from 'react-onclickoutside';
import { compose, onlyUpdateForKeys, withHandlers, withState } from 'recompose';

const AUTOCLOSE_INTERVAL = 3000;

const autocloseHandlers = withHandlers({
  autoclose: props => () => {
    if (props.timer) {
      clearTimeout(props.timer);
    }

    const timer = setTimeout(() => {
      props.setIsOpen(false);
      props.setTimer(null);
    }, AUTOCLOSE_INTERVAL);

    props.setTimer(timer);
  },
  cancelAutoclose: props => () => {
    if (props.timer) {
      clearInterval(props.timer);
      props.setTimer(null);
    }
  },
});

export default compose(
  withState('isOpen', 'setIsOpen', false),
  withState('timer', 'setTimer', null),
  autocloseHandlers,
  withHandlers({
    handleMouseLeave: props => () => props.isOpen && props.autoclose(),
    handleMouseEnter: props => () => props.isOpen && props.cancelAutoclose(),
    handleClick: props => () => props.setIsOpen(!props.isOpen),
    handleClickOutside: props => (e) => {
      if (e.target.classList.contains('c-secondary-navigation__item')) {
        return true;
      }
      return props.setIsOpen(false);
    },
  }),
  onlyUpdateForKeys(['children', 'isOpen', 'className', 'label', 'showIcon', 'labelClassName']),
  ReactOnClickOutside,
);
